import React from "react";
import styled from "styled-components";
import BlockLayout from "./../Layout/BlockLayout";
import logoSvg from "../../assets/img/scb_logo_vit.svg";
import logoPng from "../../assets/img/scb_logo_vit.png";
import { Inter, fontSizeSmall } from "./../../Util/StyleProps";
import { black, lineColor, secondaryColor } from "./../../Util/Colors";

const FooterWrapper = styled.footer`
  background: ${secondaryColor};
  width: 100%;
  min-height: 144px;
  padding-bottom: 40px;
  padding-top: 40px;
`;
const Text = styled.p`
  color: #fff;
  font-family: ${Inter};
  font-size: ${fontSizeSmall};
  line-height: 18px;
  margin-top: 16px;
`;

const Navigation = styled.nav`
  max-width: 327px;
  margin: 0 auto;
  text-align: center;
`;

const Link = styled.a`
  margin: 0 auto;
  text-align: center;
  display: block;
`;

const Logo = styled.img`
  width: 36px;
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <BlockLayout paddingTop="0" paddingBottom="0" margin="0">
        <Navigation>
          <Link href="http://www.scb.se" aria-label="Till scb.se">
            <Logo src={logoSvg} alt="Statistika Centralbyrån" />
          </Link>
          <Text>
            Statistikmyndigheten SCB förser samhället med statistik för
            beslutsfattande, debatt och forskning.
          </Text>
        </Navigation>
      </BlockLayout>
    </FooterWrapper>
  );
};

export default Footer;
